// import components
import { TextField } from '@mui/material';
import ColorPickerPopover from 'components/shared/ColorPickerPopover';
import { GridCompact6, GridContainerFlex } from '../Grid/Grid.components';

// import hooks
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// import types
import { HexColor } from '../ColorPickerPopover/ColorPickerPopover.types';

function DutyCodeBaseFields() {
  const { t } = useTranslation('common');
  const { control, setValue } = useFormContext();

  const onColorSelect = (color: HexColor) => {
    setValue('colorCode', color, { shouldDirty: true });
  };

  return (
    <GridContainerFlex>
      <GridCompact6>
        <Controller
          name="displayDutyCode"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              fullWidth
              {...field}
              label={t('dutyCode')}
              slotProps={{
                htmlInput: {
                  maxLength: 10
                }
              }}
              error={!!fieldState.error}
              helperText={fieldState.error?.message ?? null}
              variant="outlined"
              size="small"
              required
            />
          )}
        />
      </GridCompact6>
      <Controller
        name="colorCode"
        control={control}
        render={({ field }) => (
          <ColorPickerPopover
            color={field.value ?? ''}
            onColorSelected={onColorSelect}
            hasEditFeature={true}
            label={t('color')}
          />
        )}
      />
    </GridContainerFlex>
  );
}

export default DutyCodeBaseFields;
